export const LeftArrow = (color) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.65333 1.94965e-07L0 7.95354L7.65333 16L8.95111 14.6527L3.53778 8.95703L16 8.95703V7.04297L3.47556 7.04297L8.95111 1.35656L7.65333 1.94965e-07Z"
            fill="#007AC2"
        />
    </svg>
  
);
